import React from 'react';
import { ReactComponent as ImageProductDomain } from '../../media/product-domain.svg';

const HGImageProductDomain = () => {
  const alt = 'Hospedagem de Sites';

  return (
    <ImageProductDomain aria-label={alt} />
  );
};

export default HGImageProductDomain;
